import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import userReducer from './userReducer'
import { apiReducer } from './apiReducer'
export const store = (preloadedState) => configureStore({
  reducer: {
    user: userReducer,
    [apiReducer.reducerPath]: apiReducer.reducer,
  },
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiReducer.middleware),
})

setupListeners(store().dispatch)